"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _reactVirtualized = require("react-virtualized");

var _Constants = require("FileManagerLib/Constants");

var _reactDom = require("react-dom");

var ANIMATION_DURATION = 200;
/**
 * FIXME:
 * See: https://issues.hubspotcentral.com/browse/FM-245
 * See: https://git.hubteam.com/HubSpot/FileManagerUI/pull/1163
 * Due to issues with firefox and virtualized collections sometimes not rendering, the parent container
 * for this component will remount itself instead of updating correctly. Therefore we need to
 * keep track of the latest scrollTop, and save it so we can resume from the same positions instead
 * of jumping back to the top.
 */

var scrollTopCache = null;

var AnimatedCollection =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AnimatedCollection, _Component);

  function AnimatedCollection(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AnimatedCollection);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AnimatedCollection).call(this, props));
    _this.setRef = _this.setRef.bind((0, _assertThisInitialized2.default)(_this));
    _this.startAnimation = _this.startAnimation.bind((0, _assertThisInitialized2.default)(_this));
    _this.onScroll = _this.onScroll.bind((0, _assertThisInitialized2.default)(_this));
    _this.getShouldAllItemsBeRendered = _this.getShouldAllItemsBeRendered.bind((0, _assertThisInitialized2.default)(_this));
    _this.getOverwrittenCollectionProps = _this.getOverwrittenCollectionProps.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      scrollTop: scrollTopCache
    };
    return _this;
  }

  (0, _createClass2.default)(AnimatedCollection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;

      if (this.props.scrollToCell) {
        /* Due to above mentioned firefox issue, we need to wait for the parent component
           to finish remounting before we trigger an animation or else the animation will be cancelled*/
        setTimeout(function () {
          _this2.startAnimation();
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (this.props.scrollToCell !== prevProps.scrollToCell || this.props.height !== prevProps.height || this.props.width !== prevProps.width) {
        /* See comment above about Firefox bug*/
        setTimeout(function () {
          _this3.startAnimation();
        }, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "setRef",
    value: function setRef(ref) {
      var refAnimatedCollection = this.props.refAnimatedCollection;
      if (refAnimatedCollection) refAnimatedCollection(ref);
      this._collection = ref;
    }
  }, {
    key: "getOverwrittenCollectionProps",
    value: function getOverwrittenCollectionProps() {
      return (0, _extends2.default)({}, this.props, {
        ref: this.setRef,
        scrollTop: this.state.scrollTop,
        onScroll: this.onScroll,
        scrollToCell: undefined
      });
    }
  }, {
    key: "getShouldAllItemsBeRendered",
    value: function getShouldAllItemsBeRendered() {
      if (this.state.scrollTop === 0) return false;
      var collectionNode = (0, _reactDom.findDOMNode)(this._collection);
      if (!collectionNode) return false;
      var childClientHeight = collectionNode.firstChild && collectionNode.firstChild.clientHeight;
      return childClientHeight != null && childClientHeight < collectionNode.clientHeight;
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this4 = this;

      requestAnimationFrame(function () {
        if (!_this4._isMounted || !_this4._animationStartTime) return;
        var now = performance.now();
        var elapsed = now - _this4._animationStartTime;
        var scrollDelta = _this4._scrollTopFinal - _this4._scrollTopInitial;
        var easedTime = Math.min(1, elapsed / ANIMATION_DURATION);
        var scrollTop = _this4._scrollTopInitial + scrollDelta * easedTime;

        _this4.setState({
          scrollTop: scrollTop
        });

        if (elapsed < ANIMATION_DURATION) {
          _this4.animate();
        } else {
          scrollTopCache = scrollTop;
          _this4._animationStartTime = undefined;
          _this4._scrollTopInitial = _this4._scrollTopFinal;

          if (_this4.getShouldAllItemsBeRendered()) {
            _this4.setState({
              scrollTop: 0
            });

            scrollTopCache = 0;
          }
        }
      });
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var _this$props = this.props,
          scrollToCell = _this$props.scrollToCell,
          height = _this$props.height,
          width = _this$props.width,
          tiles = _this$props.tiles;
      var type = tiles.getIn([scrollToCell, 'type']);
      this._animationStartTime = performance.now();
      this._scrollTopFinal = this._collection && this._collection.getScrollPositionForCell({
        align: type === _Constants.CellTypes.FILE_DETAIL ? 'start' : 'auto',
        cellIndex: scrollToCell,
        height: height,
        scrollTop: this._scrollTopInitial,
        scrollLeft: this._scrollLeftInitial,
        width: width
      }).scrollTop || 0;
      this.animate();
    }
  }, {
    key: "onScroll",
    value: function onScroll(_ref) {
      var scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop;
      scrollTopCache = scrollTop;

      if (!this._animationStartTime) {
        this._scrollTopInitial = scrollTop;
        this._scrollLeftInitial = scrollLeft;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_reactVirtualized.Collection, this.getOverwrittenCollectionProps());
    }
  }]);
  return AnimatedCollection;
}(_react.Component);

AnimatedCollection.propTypes = {
  refAnimatedCollection: _react.PropTypes.func,
  scrollToCell: _react.PropTypes.number,
  height: _react.PropTypes.number.isRequired,
  width: _react.PropTypes.number.isRequired,
  tiles: _react.PropTypes.instanceOf(_immutable.List).isRequired
};
var _default = AnimatedCollection;
exports.default = _default;
module.exports = exports.default;